(function (WebViewJavascriptBridge) {
  const protoPrefix = 'Y2xvc2VsaXdlYg==';
  if (WebViewJavascriptBridge) {
      return;
  }
  let messagingIframe;
  let sendMessageQueue = [];
  let receiveMessageQueue = [];
  let messageHandlers = {};   // 注册messageHandlers，让app来调用

  let CUSTOM_PROTOCOL_SCHEME = atob(protoPrefix);
  let QUEUE_HAS_MESSAGE = '__QUEUE_MESSAGE__';

  let responseCallbacks = {};
  let uniqueId = 1;

  function _createQueueReadyIframe(doc) {
      messagingIframe = doc.createElement('iframe');
      messagingIframe.style.display = 'none';
      doc.documentElement.appendChild(messagingIframe);
      setIframeSrc(CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE);
  }

  //add by hq
  let isAndroid = (function () {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('android') > -1;
  })();

  //add by hq
  let isIos = (function () {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1
          //https://www.jianshu.com/p/0bfba8ee6ded 更新了IOS13以后，ipad加载WKWebView宽度超过375的时候，UA会变成Macintosh，导致H5端无法识别。
          || ua.indexOf('macintosh') > -1 || ua.indexOf('mac os') > -1 || ua.indexOf('ios') > -1;
  })();

  //set default messageHandler
  function init(messageHandler) {
      if (WebViewJavascriptBridge._messageHandler) {
          throw new Error('WebViewJavascriptBridge.init called twice');
      }
      WebViewJavascriptBridge._messageHandler = messageHandler;
      let receivedMessages = receiveMessageQueue;
      receiveMessageQueue = null;
      for (let i = 0; i < receivedMessages.length; i++) {
          _dispatchMessageFromObjC(receivedMessages[i]);
      }
  }

  function send(data, responseCallback) {
      _doSend({ data: data }, responseCallback);
  }

  function registerHandler(handlerName, handler) {
      messageHandlers[handlerName] = handler;
  }

  function callHandler(handlerName, data, responseCallback) {
      _doSend({ handlerName: handlerName, data: data }, responseCallback);
  }

  function _doSend(message, responseCallback) {
      if (responseCallback) {
          let callbackId = 'cb_' + (uniqueId++) + '_' + new Date().getTime();
          responseCallbacks[callbackId] = responseCallback;
          message['callbackId'] = callbackId;
          //alert("callbackId------"+callbackId);
      }
      sendMessageQueue.push(message);
      window.console && console.log(JSON.stringify(message));
      setIframeSrc(CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE);   //同通知app 有数据要取
      window.WebViewBridgeNativeEmulator && window.WebViewBridgeNativeEmulator.onMessage(message);
  }

  function _fetchQueue() {   //通知app队列里面有数据之后，app 会调用这个方法来取数据
      let messageQueueString = JSON.stringify(sendMessageQueue);
      sendMessageQueue = [];
      //add by hq
      if (isIos) {
          return messageQueueString;
          //android can't read directly the return data, so we can reload iframe src to communite with java
      } else if (isAndroid) {
          setIframeSrc(CUSTOM_PROTOCOL_SCHEME + '://return/_fetchQueue/' + encodeURIComponent(messageQueueString));

      }
      //console.info(messageQueueString);
  }

  let srcQueue = [];
  let isProcessing = false;
  let currentIframeSrc = '';
  let lastSetTime = 0;
  let delayTime = 50;

  function setIframeSrc(src) {
      srcQueue.push(src);
      processQueue();
  }

  function processQueue() {
      if (isProcessing || !srcQueue.length) return;

      isProcessing = true;
      let src = srcQueue.shift();
      let time = new Date().getTime();
      if (currentIframeSrc && currentIframeSrc !== src && time - lastSetTime < delayTime) {
          setTimeout(function () {
              //console.info('==currentIframeSrc 1== ' + currentIframeSrc + ' ===src===' + src);
              currentIframeSrc = messagingIframe.src = src;
              isProcessing = false;
              lastSetTime = time + delayTime;
              processQueue();
          }, delayTime);
      } else {
          //console.info('==currentIframeSrc 2== ' + currentIframeSrc + ' ===src===' + src);
          currentIframeSrc = messagingIframe.src = src;
          isProcessing = false;
          lastSetTime = time;
          processQueue();
      }
  }


  function _dispatchMessageFromObjC(messageJSON) {
      setTimeout(function _timeoutDispatchMessageFromObjC() {
          window.console && console.log(messageJSON);   //JSON.parse('{"action":"record:click","starttime":11111111,"endtime":22222222}');
          let message = JSON.parse(messageJSON);
          let messageHandler, responseCallback;
          if (message.responseId) {   // 发送的数据，响应回来的，带了responseId回来，找到responseCallbacks执行
              responseCallback = responseCallbacks[message.responseId];
              if (!responseCallback) {
                  return;
              }
              let responsDataZ = message.responseData;
              if (typeof responsDataZ == 'string') {
                  try {
                      responsDataZ = JSON.parse(responsDataZ);
                  } catch (exception) {
                      console.log('WebViewJavascriptBridge: WARNING: responseData json error.');
                      return;
                  }
              }
              responseCallback(responsDataZ);
              delete responseCallbacks[message.responseId];
          } else {
              if (message.callbackId) {   //app 来回调我，发现有callbackId，那是要响应的
                  let callbackResponseId = message.callbackId;
                  responseCallback = function (responseData) {
                      _doSend({ responseId: callbackResponseId, responseData: responseData });
                  };
              }

              let handler = WebViewJavascriptBridge._messageHandler;
              if (message.handlerName) {   //如果调用的是指定的方法，那调用指定的方法，其他调用的是初始化方法
                  handler = messageHandlers[message.handlerName];
              }
              try {
                  handler(message.data, responseCallback);
              } catch (exception) {
                  if (typeof console != 'undefined') {
                      console.log('WebViewJavascriptBridge: WARNING: javascript handler threw.', message, exception);
                  }
              }
          }
      }, 0);
  }

  function _handleMessageFromObjC(messageJSON) {
      if (receiveMessageQueue) {
          receiveMessageQueue.push(messageJSON);
      } else {
          _dispatchMessageFromObjC(messageJSON);
      }
  }

  WebViewJavascriptBridge = window.WebViewJavascriptBridge = {
      init: init,
      send: send,
      registerHandler: registerHandler,
      callHandler: callHandler,
      _fetchQueue: _fetchQueue,
      //ios
      _handleMessageFromObjC: _handleMessageFromObjC,
      //android
      _handleMessageFromNative: _handleMessageFromObjC
  };

  let doc = document;
  _createQueueReadyIframe(doc);
  let readyEvent = doc.createEvent('Events');
  readyEvent.initEvent('WebViewJavascriptBridgeReady', true, true);
  readyEvent.bridge = WebViewJavascriptBridge;
  doc.dispatchEvent(readyEvent);
})(window.WebViewJavascriptBridge);

(function connectWebViewJavascriptBridge(callback) {
  let WebViewJavascriptBridge = window.WebViewJavascriptBridge;
  if (WebViewJavascriptBridge) {
      callback(WebViewJavascriptBridge);
  } else {
      document.addEventListener('WebViewJavascriptBridgeReady',
          function () {
              callback(WebViewJavascriptBridge);
          },
          false);
  }
})(function (bridge) {
  let callbacks = {};
  bridge.Events = {
      on: function (name, handler) {
          callbacks[name] = callbacks[name] || [];
          callbacks[name].push(handler);
          return this;
      },
      off: function (name, handler) {
          if (!name) {
              callbacks = {};
              return this;
          }
          if (handler) {
              let handlers = callbacks[name] || [];
              for (let i = handlers.length - 1; i >= 0; i--) {
                  if (handlers[i] == handler) {
                      handlers.splice(i, 1);
                      return;
                  }
              }
          }
          name && delete callbacks[name];
          return this;
      },
      trigger: function (name, args) {
          let handlers = callbacks[name] || [];
          for (let i = handlers.length - 1; i >= 0; i--) {
              if (false === handlers[i].apply(this, args)) break;
          }
          return this;
      },
      hasHandler: function (name) {
          return callbacks[name] && callbacks[name].length;
      }
  };

  bridge.init(function (message, responseCallback) {
      if (typeof message == 'string') message = JSON.parse(message);
      if (message && message.action) {
          if (message.action == 'message' && message.data && message.data.activity && bridge.Events.hasHandler(message.data.activity)) {
              bridge.Events.trigger(message.data.activity, [message.data, responseCallback]);
          }
          bridge.Events.trigger(message.action, [message, responseCallback]);
      }
  });
  /*
      bridge.registerHandler("functionInJs",
      function(data, responseCallback) {

      });*/

});
